import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DEMO_EMAIL, DEMO_PASSWORD, useAuthStore } from "../auth";

export function Login() {
	const login = useAuthStore((s) => s.login);
	const navigate = useNavigate();
	const [params] = useSearchParams();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const result = login(email, password);
		if (result.ok) {
			const next = params.get("next") || "/products";
			navigate(next, { replace: true });
		} else {
			setError(result.error);
		}
	};

	return (
		<section className="max-w-md mx-auto">
			<h1 className="text-3xl font-bold text-slate-900">Log in</h1>
			<div className="mt-4 rounded-md border border-slate-200 bg-slate-100 p-3 text-sm text-slate-700">
				<p className="font-medium">Demo credentials</p>
				<p className="font-mono text-xs mt-1">Email: {DEMO_EMAIL}</p>
				<p className="font-mono text-xs">Password: {DEMO_PASSWORD}</p>
			</div>
			<form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
				<label className="flex flex-col gap-1 text-sm">
					<span className="text-slate-700">Email</span>
					<input
						type="email"
						value={email}
						onChange={(event) => setEmail(event.target.value)}
						data-testid="login-email"
						autoComplete="email"
						required
						className="rounded-md border border-slate-300 px-3 py-2"
					/>
				</label>
				<label className="flex flex-col gap-1 text-sm">
					<span className="text-slate-700">Password</span>
					<input
						type="password"
						value={password}
						onChange={(event) => setPassword(event.target.value)}
						data-testid="login-password"
						autoComplete="current-password"
						required
						className="rounded-md border border-slate-300 px-3 py-2"
					/>
				</label>
				{error && (
					<p
						data-testid="login-error"
						className="text-sm text-red-600"
						role="alert"
					>
						{error}
					</p>
				)}
				<button
					type="submit"
					data-testid="login-submit"
					className="btn-primary"
				>
					Log in
				</button>
			</form>
		</section>
	);
}

export default Login;
